// Determine API URL based on hostname
const getApiUrl = () => {
  if (window.location.hostname === 'staging.veralonai.com') {
    return 'https://staging.veralonai.com/api';
  }
  return 'https://api.veralonai.com';
};

export const API_URL = getApiUrl();
